module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.className,
    attrs: {
      "title": _vm.title
    },
    on: {
      "click": _vm.dayClicked
    }
  }, [_c('div', {
    staticClass: "day-value"
  }, [_vm._v("\n        " + _vm._s(_vm.date.getDate()) + "\n        \n    ")]), _vm._v(" "), _c('div', {
    staticClass: "has-data"
  }, [(_vm.hasNoise) ? _c('div', {
    staticClass: "has-noise"
  }) : _vm._e(), _vm._v(" "), (_vm.hasAudio) ? _c('div', {
    staticClass: "has-audio"
  }) : _vm._e(), _vm._v(" "), (_vm.hasWeather) ? _c('div', {
    staticClass: "has-weather"
  }) : _vm._e(), _vm._v(" "), (_vm.hasVideo) ? _c('div', {
    staticClass: "has-video"
  }) : _vm._e(), _vm._v(" "), (_vm.hasAdio) ? _c('div', {
    staticClass: "has-adio"
  }) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-413d59e2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/CalendarDay.vue
// module id = 456
// module chunks = 1